import React from 'react';
import ReactSelect from 'react-select';

const Select = React.forwardRef(({ label, error, options, value, onChange, ...props }, ref) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: error ? '#FCA5A5' : '#D1D5DB',
      '&:hover': {
        borderColor: error ? '#EF4444' : '#6366F1',
      },
      borderColor: localStorage.getItem('theme') === 'dark' ? 'rgb(75 85 99)' : 'white',
      boxShadow: state.isFocused ? '0 0 0 1px #6366F1' : 'none',
      backgroundColor: localStorage.getItem('theme') === 'dark' ? '#374151' : 'white',
      color: localStorage.getItem('theme') === 'dark' ? 'white' : '#374151',
      

    }),
    singleValue: (base) => ({
      ...base,
      padding: 8,
      position:"relative",
      
      borderRadius: 5,
      color: localStorage.getItem('theme') === "dark" ? "white" : "rgb(55 65 81)",
      display: 'flex',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#6366F1' : state.isFocused ? '#E0E7FF' : 'white',
      color: state.isSelected ? 'white' : '#374151',
    })
  };

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-1">
          {label}
        </label>
      )}
      <ReactSelect
        ref={ref}
        options={options}
        value={options.find(option => option.value === value)}
        onChange={(selected) => onChange(selected.value)}
        styles={customStyles}
        className="react-select-container relative "
        classNamePrefix="react-select"
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error.message}</p>
      )}
    </div>
  );
});

export default Select;